import { ItemState } from '@/app-constants';

export const CREATE_CHANGE_REQUEST = {
  SHOW: 'SHOW_CHANGE_REQUEST_FORM',
  HIDE: 'HIDE_CHANGE_REQUEST_FORM',
  REQUEST: 'CREATE_CHANGE_REQUEST_REQUEST',
  SUCCESS: 'CREATE_CHANGE_REQUEST_SUCCESS',
  FAILURE: 'CREATE_CHANGE_REQUEST_FAILURE'
};

export function showChangeRequest(payload) {
  return {
    payload,
    type: CREATE_CHANGE_REQUEST.SHOW
  };
}

export function hideChangeRequest() {
  return {
    type: CREATE_CHANGE_REQUEST.HIDE
  };
}

export interface ICreateChangeRequestPayload {
  purchaseOrderId: number;
  purchaseOrderItemId?: number;
  purchaseOrderItemIds?: number[];
  requestedDate: string;
  reasonTypeId: number;
  stateId: ItemState;
  quantity?: string;
  comments: string;
  unitPrice?: string;
}
export function createChangeRequest(payload: ICreateChangeRequestPayload) {
  return {
    payload,
    type: CREATE_CHANGE_REQUEST.REQUEST
  };
}

export interface ICreateChangeRequestSuccessPayload {
  purchaseOrderItemId: number;
  stateId: number;
  changeRequestAlreadyExistsForItems: boolean;
}
export function createChangeRequestSuccess(payload: ICreateChangeRequestSuccessPayload) {
  return {
    payload,
    type: CREATE_CHANGE_REQUEST.SUCCESS
  };
}

export function createChangeRequestFailure(payload) {
  return {
    payload,
    type: CREATE_CHANGE_REQUEST.FAILURE
  };
}
